<template>
  <div class="QuestionTitle">
    <h2 class="QuestionTitle__title">{{ title }}</h2>
  </div>
</template>

<script>
export default {
  name: 'QuestionTitle',
  props: {
    title :  {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.QuestionTitle {
  
}
.QuestionTitle__title {

}
</style>



// WEBPACK FOOTER //
// src/components/Services/ServicesQuestions/QuestionTitle.vue